import React, { useEffect, useState } from 'react'
import '../../Css/Savani.css'
import kalathiya from '../../Image/kalathiya_contact.svg'
import boss1 from '../../Image/boss1.svg'
import boss2 from '../../Image/boss2.svg'
import word from '../../Image/Contact/wordpress.svg'
import code from '../../Image/Contact/codeingniter.svg'
import php from '../../Image/Contact/php.svg'
import fish from '../../Image/Contact/fish.svg'
import lara from '../../Image/Contact/laravel.svg'
import dart from '../../Image/Contact/dart.svg'
import view from '../../Image/Contact/view.svg'
import nuxt from '../../Image/Contact/nuxt.svg'
import html from '../../Image/Contact/html.svg'
import sql from '../../Image/Contact/sql.svg'
import android from '../../Image/Contact/android.svg'
import firebase from '../../Image/Contact/firebase.svg'
import mongo from '../../Image/Contact/mongo.svg'

import ai from '../../Image/Contact/ai.svg'
import xd from '../../Image/Contact/xd.svg'
import ps from '../../Image/Contact/ps.svg'
import python from '../../Image/Contact/python.svg'
import react from '../../Image/Contact/react.svg'
import node from '../../Image/Contact/node.svg'
import tailwind from '../../Image/Contact/tailwind.svg'
import scaper from '../../Image/Contact/scraper.svg'
import next from '../../Image/Contact/next.svg'
import psql from '../../Image/Contact/postgre.svg'
import mac from '../../Image/Contact/apple.svg'
import figma from '../../Image/Contact/figma.svg'
import css from '../../Image/Contact/css.svg'
import ThinkContact from './ThinkContact'

import Marquee from "react-fast-marquee";
import Wave from 'react-wavify'

const MeetContact = () => {
  const [marqueeSpeed, setMarqueeSpeed] = useState(200); // Default for desktop
  useEffect(() => {
    const updateSpeed = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setMarqueeSpeed(50); // Slower speed for small screens
      } else if (width < 1024) {
        setMarqueeSpeed(120); // Medium speed for tablets
      } else {
        setMarqueeSpeed(200); // Faster for large screens
      }
    };
  
    updateSpeed(); // Run on mount
    window.addEventListener('resize', updateSpeed); // Update on resize
    return () => window.removeEventListener('resize', updateSpeed);
  }, []);
  return (
    <div className='overflow-hidden'>
      <Wave fill='#F6F6F6' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className=' bg-white relative min-w-[1920px] h-[28px] ' />
      <div className='bg-[#F6F6F6] pb-[70px]'>
        <div className='container '>
          <div className='flex justify-center pt-5'>
            <img src={kalathiya} alt="" className='4xl:w-auto 3xl:w-auto ' />
          </div>
        </div>
        <div>
          <h2 className="2xl:-mt-[89px] xl:-mt-[75px] lg:-mt-[66px] md:-mt-[55px] sm:-mt-[43px] sx:-mt-[32px] 2xl:text-[60px] xl:text-[53px] lg:text-[47px] md:text-[40px] sm:text-[30px] sx:text-[24px] text-[26px] font-[700] text-theme_dark text-center sx:leading-normal leading-[35px] sx:pt-0 pt-3 sx:px-0 px-2">Meet Our Secret Originators</h2>
          <div className='container'>
            <div className='flex md:flex-nowrap flex-wrap items-stretch justify-center mt-8'>
              <div className="4xl:w-1/4  3xl:w-1/4 2xl:w-1/4 xl:w-1/3 lg:w-2/5 md:w-1/2 sm:w-3/4 w-full sx:px-7">
                <div className='ds_contact_gradient h-full sx:rounded-[70px] rounded-[50px] pb-2'>
                  <div className='flex justify-center pt-7'>
                    <img src={boss1} alt="" className='sm:w-[250px] w-[200px]' />
                  </div>
                  <div className='bg-white shadow-[0_0_4px_0_#8A49D6] rounded-tl-[20px] rounded-tr-[20px] rounded-br-[71px] rounded-bl-[71px] mx-2'>
                    <div className='text-center pt-4'>
                      <p className='sm:text-[22px] text-[18px] text-theme_dark font-[700]'>Vishal Kalathiya</p>
                      <p className='text-txt_color sm:text-[16px] text-[14px] font-[700] pb-3'>CO-ORDINATORS</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="4xl:w-1/4  3xl:w-1/4 2xl:w-1/4 xl:w-1/3 lg:w-2/5 md:w-1/2 sm:w-3/4 w-full sx:px-7 md:mt-0 mt-5">
                <div className='ds_contact_gradient h-full sx:rounded-[70px] rounded-[50px] pb-2'>
                  <div className='flex justify-center pt-10'>
                    <img src={boss2} alt="" className='sm:w-[250px] w-[200px]' />
                  </div>
                  <div className='bg-white shadow-[0_0_4px_0_#8A49D6] rounded-tl-[20px] rounded-tr-[20px] rounded-br-[71px] rounded-bl-[71px] mx-2'>
                    <div className='text-center pt-4'>
                      <p className='sm:text-[22px] text-[18px] text-theme_dark font-[700]'>Abhishek Kalathiya</p>
                      <p className='text-txt_color sm:text-[16px] text-[14px] font-[700] pb-3'>CO-ORDINATORS</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='pt-11'>
            <div className='pt-5'>
              <div className='ds_core_shdow bg-white py-5'>
                <div className='overflow-hidden mt-7 pb-5'>
                  <Marquee speed={marqueeSpeed} pauseOnHover="false" className='cursor-pointer'>
                    <div className="flex justify-center">
                      <img src={word} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={code} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={php} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={fish} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={lara} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={dart} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={view} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={nuxt} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={html} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={sql} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={android} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={firebase} alt="" className="mx-10" />
                    </div>
                    <div className="flex justify-center">
                      <img src={mongo} alt="" className="mx-10" />
                    </div>
                  </Marquee>

                  <Marquee speed={marqueeSpeed} direction='right' pauseOnHover="false" className='mt-8 cursor-pointer8'>
                    <div>
                      <div className='flex justify-center'>
                        <img src={ai} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={xd} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={ps} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={python} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={react} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={node} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={tailwind} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={scaper} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={next} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={psql} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={mac} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={figma} alt="" className="mx-[50px]" />
                      </div>
                    </div>
                    <div>
                      <div className='flex justify-center'>
                        <img src={css} alt="" className="mx-[50px]" />
                      </div>
                    </div>

                  </Marquee>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ThinkContact />
    </div>
  )
}

export default MeetContact
